import { Snackbar, Alert } from "@mui/material";
import { ToastState } from "@/hooks/useToast";

interface ToastProps {
    toast: ToastState;
    onClose: () => void;
}

export default function Toast({ toast, onClose }: ToastProps) {
    return (
        <Snackbar
            open={toast.open}
            autoHideDuration={6000}
            onClose={onClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
            <Alert
                onClose={onClose}
                severity={toast.severity}
                sx={{ width: "100%" }}
                elevation={6}
                variant="filled"
            >
                {toast.message}
            </Alert>
        </Snackbar>
    );
}
